<template>
    <div class="custom-form-page">
        <h2 class="page-title">{{ pageTitle }}</h2>

        <div class="notification">
            {{ $t('source.fields_with_an_asterisk_are_mandatory_according_to_the_apa_guidelines') }}
        </div>

        <div class="custom-form-questions">
            <div
                class="custom-form-question"
                v-for="question of questionsIn"
                :key="question.model.id">
                <div v-if="question.model.header_text">
                    <p>
                        {{ question.model.header_text }}
                    </p>
                </div>

                <custom-form-create-question-input-component
                    v-if="question.model.type === 1 || question.model.type === 6"
                    :question-in="question.model"
                    :has-error="question.hasError"
                    :error-text="question.errorText"
                    :value="question.answer"
                    :key="question.model.id"
                    @update-answer="updateAnswer($event)">
                </custom-form-create-question-input-component>
                <custom-form-create-question-date-component
                    v-if="question.model.type === 2"
                    :question-in="question.model"
                    :has-error="question.hasError"
                    :error-text="question.errorText"
                    :value="question.answer"
                    :key="question.model.id"
                    @update-answer="updateAnswer($event)">
                </custom-form-create-question-date-component>
                <custom-form-create-question-radio-component
                    v-if="question.model.type === 3"
                    :question-in="question.model"
                    :has-error="question.hasError"
                    :error-text="question.errorText"
                    :value="question.answer"
                    :key="question.model.id"
                    @update-answer="updateAnswer($event)">
                </custom-form-create-question-radio-component>
                <custom-form-create-question-checkbox-component
                    v-if="question.model.type === 4"
                    :question-in="question.model"
                    :has-error="question.hasError"
                    :error-text="question.errorText"
                    :value="question.answer"
                    :key="question.model.id"
                    @update-answer="updateAnswer($event)">
                </custom-form-create-question-checkbox-component>
                <custom-form-create-question-signature-component
                    v-if="question.model.type === 5"
                    :question-in="question.model"
                    :has-error="question.hasError"
                    :error-text="question.errorText"
                    :value="question.answer"
                    :key="question.model.id"
                    @update-answer="updateAnswer($event)">
                </custom-form-create-question-signature-component>
            </div>
        </div>

        <div class="custom-form-navigate">
            <b-button
                class="btn-previous-custom-form-page"
                v-if="previousButton"
                variant="outline-primary"
                @click="previousPage">
                Vorige
            </b-button>
            <b-button
                class="btn-next-custom-form-page"
                v-if="nextButton"
                variant="primary"
                @click="nextPage">
                Volgende
            </b-button>
            <b-button
                class="btn-submit-custom-form"
                v-if="submitButton"
                variant="primary"
                @click="submitForm">
                Verstuur
            </b-button>
        </div>
    </div>
</template>

<script>
export default {
    name: 'custom-form-create-page-component',
    props: {
        pageTitle: {
            type: String,
            required: true,
        },
        questionsIn: {
            type: Array,
            required: true,
        },
        previousButton: {
            type: Boolean,
            required: true,
        },
        nextButton: {
            type: Boolean,
            required: true,
        },
        submitButton: {
            type: Boolean,
            required: true,
        },
    },
    methods: {
        updateAnswer(answer) {
            this.$emit('update-answer', answer);
        },
        previousPage() {
            this.$emit('previous-page');
        },
        nextPage() {
            this.$emit('next-page');
        },
        submitForm() {
            this.$emit('submit-form');
        },
    },
};
</script>

<style scoped lang="scss">
.page-title {
    font-size: 1.5625rem;
    margin-top: map-get($grid-gutter-spacing, 'fifteen');
    margin-bottom: map-get($grid-gutter-spacing, 'forty-two');
}

.notification {
    color: $text-muted-color;
    margin-bottom: map-get($grid-gutter-spacing, 'twenty-one');
}

.custom-form-navigate {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-end;
    column-gap: map-get($grid-gutter-spacing, 'fifteen');
    margin-top: map-get($grid-gutter-spacing, 'forty-two');
    margin-top: map-get($grid-gutter-spacing, 'forty-two');
}

.custom-form-question ::v-deep {
    margin-bottom: $grid-gutter-width;

    .alert {
        margin-bottom: map-get($grid-padding-spacing, 'eight');
    }
}
</style>
